// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body#portal #marketing-help[data-v-3859a152] {
  line-height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/application/business/business_info.vue","webpack://./business_info.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;ACAF","sourcesContent":["\nbody#portal #marketing-help {\n  line-height: 18px;\n}\n","body#portal #marketing-help {\n  line-height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
